import { StatusOptions } from 'components/DetailsView/DetailFormStatusValue';
import { colors } from 'constants/colors';
import { SiteContractType } from 'data/__generated__';

export const SITE_CONTRACT_TYPES_OPTIONS: Record<SiteContractType, StatusOptions> = {
    [SiteContractType.Subscription]: {
        backgroundColor: colors.blandBlue,
        labelColor: colors.black,
        label: 'Abonnement',
    },
    [SiteContractType.FreeDeposit]: {
        backgroundColor: colors.orange,
        labelColor: colors.black,
        label: 'Dépôt gratuit',
    },
};
